module.exports = __webpack_public_path__ + "static/img/4.97499fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/4.png
// module id = XiOK
// module chunks = 0